import PartnerAccountInfoTable from './PartnerAccountInfoTable';

export default PartnerAccountInfoTable;
